import getContrastFontColor from '@utils/getContrastFontColor';
import { media } from 'styled-bootstrap-grid';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ small: boolean }>`
  --xl-font-size: 1rem;
  --xl-padding: 11px;
  display: inline-block;
  font-size: var(--xl-font-size);
  line-height: 1;
  letter-spacing: 0.06em;
  background: ${({ theme }) => theme.customColors.primary};
  color: ${({ theme }) =>
    getContrastFontColor(theme.defaultColors.fontPrimary, theme.customColors.primary)};
  border-radius: 2px;
  opacity: 1;
  text-decoration: none;
  padding: var(--xl-padding);

  ${(props) =>
    props.small &&
    css`
      font-size: 0.875rem;
      padding: 9px;

      ${media.xl`
        font-size: var(--xl-font-size);
        padding: var(--xl-padding);
      `}
    `}
`;
